import Vue, { VueConstructor } from 'vue'
import { AuthState, getIdToken, state } from '@/libs/Auth'

declare module 'vue/types/vue' {
  interface Vue {
    $auth: AuthState
  }
}

const authPlugin = {
  install: (vue: VueConstructor) => {
    vue.prototype.$getIdToken = getIdToken
    vue.prototype.$auth = Vue.observable(state)
  }
}

export default authPlugin
